module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.nip)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_nip"
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.nip),
      expression: "item.nip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_nip"
    },
    domProps: {
      "value": (_vm.item.nip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "nip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.nip) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_nip_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.nip))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.regon)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_regon"
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.regon),
      expression: "item.regon"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_regon"
    },
    domProps: {
      "value": (_vm.item.regon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "regon", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.regon) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_regon_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.regon))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.krs)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_krs"
    }
  }, [_vm._v("KRS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.krs),
      expression: "item.krs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_krs"
    },
    domProps: {
      "value": (_vm.item.krs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "krs", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.krs) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_krs_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.krs))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.street)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_street"
    }
  }, [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.street),
      expression: "item.address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_street"
    },
    domProps: {
      "value": (_vm.item.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.street) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_street_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_number"
    }
  }, [_vm._v("Numer domu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.number),
      expression: "item.address.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_number"
    },
    domProps: {
      "value": (_vm.item.address.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_postalCode"
    }
  }, [_vm._v("Kod pocztowy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.postalCode),
      expression: "item.address.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_postalCode"
    },
    domProps: {
      "value": (_vm.item.address.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_postalCode_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.postalCode))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.city)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Miasto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.city),
      expression: "item.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_city"
    },
    domProps: {
      "value": (_vm.item.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.city) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.city))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount && (_vm.errors.bankAccount.numberPLN || _vm.errors.bankAccount.bankAccountSet))
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccount_numberPLN"
    }
  }, [_vm._v("Numer konta bankowego (PLN)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.bankAccount.numberPLN),
      expression: "item.bankAccount.numberPLN"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_bankAccount_numberPLN"
    },
    domProps: {
      "value": (_vm.item.bankAccount.numberPLN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.bankAccount, "numberPLN", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.numberPLN) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_numberPLN_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.numberPLN))]) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.bankAccountSet) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.bankAccountSet))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount && (_vm.errors.bankAccount.numberEUR || _vm.errors.bankAccount.bankAccountSet))
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccount_numberEUR"
    }
  }, [_vm._v("Numer konta bankowego (EUR)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.bankAccount.numberEUR),
      expression: "item.bankAccount.numberEUR"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_bankAccount_numberEUR"
    },
    domProps: {
      "value": (_vm.item.bankAccount.numberEUR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.bankAccount, "numberEUR", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.numberEUR) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_numberEUR_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.numberEUR))]) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.bankAccountSet) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_number2_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.bankAccountSet))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.phone)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Telefon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.phone),
      expression: "item.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_phone"
    },
    domProps: {
      "value": (_vm.item.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.phone) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_phone_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.phone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.website)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_website"
    }
  }, [_vm._v("Strona WWW")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.website),
      expression: "item.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_website"
    },
    domProps: {
      "value": (_vm.item.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.website) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_website_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.website))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.email)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.email),
      expression: "item.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_email"
    },
    domProps: {
      "value": (_vm.item.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.email) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_email_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.summary)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_summary"
    }
  }, [_vm._v("Podsumowanie")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.summary),
      expression: "item.summary"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "_summary"
    },
    domProps: {
      "value": (_vm.item.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "summary", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.summary) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_summary_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.summary))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'CompanyShow'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53bf5b58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Form.vue
// module id = 817
// module chunks = 0